import * as React from "react"
import styled from "styled-components"
import QRCode from "qrcode.react";
import { RiCloseCircleFill } from "react-icons/ri";


interface Props {
    link: string
    openModalQR: () => void
}

export default function ModalQRCode(props: Props) {
    const qrRef = React.useRef()
    const [url, setUrl] = React.useState("")


    const downloadQRCode = (evt: React.FormEvent) => {
        evt.preventDefault()

        let canvas =


            setUrl("")

    }

    return (
        <Content>
            <div className="qr_container_qr_code">
                <QRCode
                    value={props.link}
                    level="M"
                    fgColor="#2c3e50"
                    // imageSettings={
                    //     {
                    //         src: "https://firebasestorage.googleapis.com/v0/b/digitalmenu-e82c4.appspot.com/o/upload_images%2Fb98424df-04b9-40ef-b25e-480f1a1f78b8?alt=media"
                    //         , height: 40,
                    //         width: 40,
                    //     }
                    // }
                />
            </div>
        </Content>
    )
}


const Content = styled.div`
    width: 100%;
    display:flex;
    flex-direction:column; 
    justify-content:center; 
    align-items:center;
`